import { Box, Icon, IconSize, Menu, MenuOptions, Spinner, SpinnerSize } from '@bechtel/gds';
import { PopperContainerStyled, MenuItemStyled } from './styled';
import { Trans } from '@lingui/macro';
import { FC } from 'react';
import { WeldFlangeConnectionActionProps } from './types';

export const WeldFlangeConnectionAction: FC<WeldFlangeConnectionActionProps> = ({
  onCancelFitupRequest,
  cancelFitupRequestLoading,
}) => {
  return (
    <Box style={{ position: 'relative' }}>
      <Menu>
        {({ isOpen, toggle, close: closeMenu }) => (
          <div
            data-testid="close-menu"
            onBlur={() => {
              closeMenu();
            }}
          >
            <Icon
              onClick={() => {
                toggle();
              }}
              style={{ cursor: 'pointer' }}
              icon="ellipsis-v"
              size={IconSize.MEDIUM}
              fillColor="blue.800"
            />
            <PopperContainerStyled>
              {isOpen && (
                <MenuOptions
                  css={`
                    order: 2;
                    border-bottom-left-radius: 0px;
                    border-bottom-right-radius: 0px;
                  `}
                >
                  <MenuItemStyled
                    isDisabled={cancelFitupRequestLoading}
                    onMouseDown={(event) => {
                      onCancelFitupRequest();
                      event.preventDefault();
                    }}
                  >
                    <Trans>Cancel Request</Trans>
                    {cancelFitupRequestLoading && (
                      <>
                        &nbsp;
                        <Spinner size={SpinnerSize.SMALL} />
                      </>
                    )}
                  </MenuItemStyled>
                </MenuOptions>
              )}
            </PopperContainerStyled>
          </div>
        )}
      </Menu>
    </Box>
  );
};
